import { notificationQueryKeys } from '@/api/notifications/query-keys';
import { isSupportTicketNotificationType } from '@/api/support-ticket/models';
import { supportTicketQueryKeys } from '@/api/support-ticket/queryKeys';
import type { NotificationEvent } from './types';

/**
 * Prefisso della cache dei limiti commerciali. Non ha un modulo di query key
 * dedicato: sta qui perché è l'unico posto che lo invalida.
 */
export const COMMERCIAL_ENTITLEMENTS_QUERY_KEY = 'commercial-entitlements';

/**
 * Chiavi di cache da invalidare all'arrivo di una notifica via websocket.
 *
 * Funzione pura di `type` + tenant: è l'unico punto in cui un evento del
 * socket diventa un elenco di query da rileggere, e resta verificabile senza
 * montare il provider di react-query.
 */
export function getQueryKeysToInvalidateForNotification(
  notification: Pick<NotificationEvent, 'type'>,
  tenantId: string
): readonly unknown[][] {
  const queryKeys: unknown[][] = [
    // Un avviso di superamento limiti può arrivare dopo l'evento documento
    // (es. webhook SDI).
    [COMMERCIAL_ENTITLEMENTS_QUERY_KEY, tenantId],
    [...notificationQueryKeys.all(tenantId)],
  ];

  if (isSupportTicketNotificationType(notification.type)) {
    queryKeys.push([...supportTicketQueryKeys.all(tenantId)]);
  }

  return queryKeys;
}
